import React, { useEffect, useState } from 'react';
import { faGear } from '@fortawesome/free-solid-svg-icons';
import { Modal, Toggle } from '@quyva/shared-ui';
import { toSentenceCase } from '@quyva/common';

export const Settings = ({
    setShowSettingsModal,
    enableReader,
    setEnableReader,
    enableMusic,
    setEnableMusic,
    vendorDetails,
    enableAudioFeature,
}) => {
    return (
        <Modal
            title={'Settings'}
            titleIcon={faGear}
            iconColor={'sky'}
            onClose={() => setShowSettingsModal(false)}
            className={''}
        >
            <div className='w-80 h-fit flex flex-col items-start justify-center p-4'>
                {enableAudioFeature && (
                    <>
                        <br />

                        <div
                            className='w-full flex items-center'
                            title={`Read aloud new response: ${
                                enableReader ? 'Enabled' : 'Disabled'
                            }`}
                        >
                            <Toggle
                                toggleText={'Reader'}
                                onChange={() => setEnableReader(!enableReader)}
                                checked={enableReader && enableAudioFeature}
                                toggleTextClassName={
                                    'w-1/3 mr-2 ml-0.5 font-semibold text-texts-secondary300'
                                }
                            />
                        </div>
                    </>
                )}

                <br />

                <div
                    className='w-full flex items-center'
                    title={`Waiting Music: ${
                        enableMusic ? 'Enabled' : 'Disabled'
                    }`}
                >
                    <Toggle
                        toggleText={'Music'}
                        onChange={() => setEnableMusic(!enableMusic)}
                        checked={enableMusic}
                        toggleTextClassName={
                            'w-1/3 mr-2 ml-0.5 font-semibold text-texts-secondary300'
                        }
                    />
                </div>
            </div>
        </Modal>
    );
};
